import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  CreateNcmRequest,
  ListNcmsQuery,
  Ncm,
  UpdateNcmRequest,
} from './Ncm.types';

import { API_BASE_URL } from '..';
import { NcmReducedInterface } from './Ncm.types';

const CONTROLLER_URL = `${API_BASE_URL}/ncm`;

export async function listNcms(
  params?: ListNcmsQuery,
): Promise<PageResult<Ncm>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Ncm>;
}

export async function getNcm(id: number): Promise<Ncm> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Ncm;
}

export async function createNcm(obj: CreateNcmRequest): Promise<Ncm> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Ncm;
}

export async function updateNcm(obj: UpdateNcmRequest): Promise<Ncm> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Ncm;
}

export async function deleteNcm(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function ncmActivateOrInactivate(ncmId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${ncmId}/activate`,
    {},
    null,
  )) as unknown;

  return result;
}
export async function reduceNcm(req: Omit<ListNcmsQuery, 'active'>) {
  const result = (await api.get(`${CONTROLLER_URL}/reduced`, req)) as unknown;

  return result as PageResult<NcmReducedInterface>;
}
